<template>
  <kst-print-table :data="items">
    <b-table-column
      v-slot="{ column, row }"
      field="DispatchID"
      :label="RinvItemCatalog.DispatchID.PrintLabel"
    >
      <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku-large"
      field="SKU"
      :label="RinvItemCatalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-qty-print"
      field="Quantity"
      :label="RinvItemCatalog.Quantity.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog">
        <kst-value field="Packaging" :data="row" :catalog="RinvItemCatalog"/>
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-price"
      field="SellPrice"
      :label="RinvItemCatalog.SellPrice.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="Total"
      :label="RinvItemCatalog.Total.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RinvItemCatalog"/>
    </b-table-column>
  </kst-print-table>
</template>

<script>
import RinvItemCatalog from "../RinvItemCatalog.js";

export default {
  props: {
    details: Object,
    items: Array
  },
  data: () => ({
    RinvItemCatalog: RinvItemCatalog
  })
}
</script>